import React, { useState } from 'react';
import { Box, Stack, Typography } from '@mui/material';
import CusInput from '../../../../../components/material-ui/CusInput';
import { useTranslation } from 'react-i18next';
import { options0To100 } from '../../../../../enums/enums';
import TabsLanguage from '../../../../../components/widgets/TabsLanguage';
import CusSwitch from '../../../../../components/material-ui/CusSwitch';
import useToast from '../../../../../hooks/useToast';
import CusQuill from '../../../../../components/material-ui/CusQuill';

export default function RegisterWithoutDeposit({
  textLang,
  setTextLang,
  selectHour,
  setSelectHour,
  defaultLang,
  setDefaultLang
}) {
  const { t } = useTranslation();
  const { infoToast, errorToast } = useToast();

  const [lang, setLang] = useState(defaultLang);

  return (
    <Stack component={'section'} gap={2}>
      <Typography variant="h6">{t('Registration without deposit')}</Typography>
      <Stack gap={1}>
        <Box>
          <CusInput
            label={
              'Send a notification if a deposit is not made within a specified number of hours after registration:'
            }
            textValuesName={'hour(s)'}
            inputSx={{ maxWidth: 80 }}
            textValuesNameTooltipText={'0 - the message is not sent.'}
            options={options0To100}
            value={+selectHour || selectHour}
            type="number"
            onChange={(e) => {
              const value = e.target.value;
              if (value < 0 || value > 999) {
                errorToast('Enter a number between 0 and 999');
                return;
              }
              setSelectHour(value);
            }}
          />
        </Box>

        <Stack gap={1}>
          <TabsLanguage lang={lang} setLang={setLang} />
          <CusSwitch
            label={'Default language'}
            key={lang + '_reg_switch'}
            checked={lang == defaultLang}
            tooltipText={
              'Turn On a different default language and it will be turned off automatically here!'
            }
            onChange={() => {
              setDefaultLang(lang);

              const textTurnOf =
                'Turn On a different default language and it will be turned off automatically here!';

              if (lang == defaultLang) infoToast(textTurnOf);
            }}
          />
          {/* <CusInput
            key={'mes-text-' + lang}
            label={'Message text'}
            rows={4}
            value={textLang[lang]}
            onChange={(e) => {
              const value = e.target.value;
              setTextLang((prev) => ({ ...prev, [lang]: value }));
            }}
          /> */}

          <CusQuill
            key={'mes-text-' + lang}
            isTgMode
            value={textLang[lang]}
            onChange={(value) => setTextLang((prev) => ({ ...prev, [lang]: value }))}
          />
        </Stack>
      </Stack>
    </Stack>
  );
}
